"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotGame = void 0;
const TemplateLoader_1 = require("@nolimit/slot-launcher/bin/loader/TemplateLoader");
const NolimitLauncher_1 = require("@nolimit/slot-launcher/bin/NolimitLauncher");
const KeypadPlugin_1 = require("@nolimit/slot-launcher/bin/plugins/KeypadPlugin");
const SoundPlugin_1 = require("@nolimit/slot-launcher/bin/plugins/SoundPlugin");
const ApiPlugin_1 = require("@nolimit/slot-launcher/bin/plugins/ApiPlugin");
const JackpotPlugin_1 = require("@nolimit/slot-launcher/bin/plugins/JackpotPlugin");
const GamblePlugin_1 = require("@nolimit/slot-launcher/bin/plugins/GamblePlugin");
const AutoPlayPlugin_1 = require("@nolimit/slot-launcher/bin/plugins/AutoPlayPlugin");
class SlotGame {
    constructor() {
        this.name = "SlotGame";
    }
    fetchPlugins() {
        for (let plugin of NolimitLauncher_1.NolimitLauncher.plugins) {
            if ((0, KeypadPlugin_1.isKeypadPlugin)(plugin)) {
                SlotGame.keypadPlugin = plugin;
            }
            if ((0, SoundPlugin_1.isSoundPlugin)(plugin)) {
                SlotGame.sound = plugin.player;
            }
            if ((0, ApiPlugin_1.isApiPlugin)(plugin)) {
                SlotGame.apiPlugin = plugin;
            }
            if ((0, JackpotPlugin_1.isJackpotPlugin)(plugin)) {
                SlotGame.jackpotPlugin = plugin;
            }
            if ((0, GamblePlugin_1.isGamblePlugin)(plugin)) {
                SlotGame.gamblePlugin = plugin;
            }
            if ((0, AutoPlayPlugin_1.isAutoPlayPlugin)(plugin)) {
                SlotGame.autoPlayPlugin = plugin;
            }
        }
        if (SlotGame.keypadPlugin == undefined) {
            return Promise.reject(new Error("SlotGame is missing KeypadPlugin"));
        }
        if (SlotGame.sound == undefined) {
            return Promise.reject(new Error("SlotGame is missing SoundPlugin"));
        }
        if (SlotGame.apiPlugin == undefined) {
            return Promise.reject(new Error("SlotGame is missing ApiPlugin"));
        }
        return Promise.resolve();
    }
    getNoWinGameData() {
        console.warn("GamePlugin.getNoWinData is not overridden in concrete game plugin, unable to soft reset");
        return undefined;
    }
    init() {
        return new Promise((resolve, reject) => {
            this.fetchPlugins().catch((reason) => {
                return Promise.reject(reason);
            });
            SlotGame.events = SlotGame.apiPlugin.eventSystemFactory.create();
            resolve(this);
        });
    }
    getReady() {
        //Show intro and load game assets
        return new Promise((resolve, reject) => {
            resolve(this);
        });
    }
    getReadyToStart() {
        //Game assets loaded, waiting for user to start game.
        return new Promise((resolve, reject) => {
            resolve(this);
        });
    }
    start() {
        //User has pressed continue and the game starts.
        return new Promise((resolve, reject) => {
            resolve(this);
        });
    }
    getPaytable() {
        const templateLoader = new TemplateLoader_1.TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });
        return templateLoader.load().then((assets) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        });
    }
    getGameRules() {
        const templateLoader = new TemplateLoader_1.TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Rules",
            url: "nolimit/screens/rules.mustache"
        });
        return templateLoader.load().then((assets) => {
            for (let asset of assets) {
                if (asset.name == "Rules" && asset.loadedData) {
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Rules");
        });
    }
}
exports.SlotGame = SlotGame;
//# sourceMappingURL=SlotGame.js.map